import { RouterProvider as Provider } from 'react-router-dom';

import { router } from '../../routers/router';

export const RouterProvider = () => {
  return <Provider router={router} />;
};
